import React, { useEffect } from "react";

import { DatePickerWithInput } from "Components/molecules/DatePickerWithInput/Desktop";
import { FieldSearch } from "../styles";
// @ts-ignore
import { ReactComponent as CalendarBackSvg } from "assets/svgs/calendar-back.svg";
import { useCalendarContext } from "shared/contexts/CalendarContext";
import { useSearchContext } from "shared/contexts/SearchContext";
import { orderDatesAsc } from "shared/utils/dates";

/**
 * Componente DataSearchOriginDesktop
 *
 * Configuração para datas de origem no layout Desktop.
 */
export const DataSearchOriginDesktop: React.FC = () => {
  const { daysInMonth, selectedOriginDates, setSelectedOriginDates } =
    useCalendarContext();
  const { setDepartureDates, searchState } = useSearchContext();

  const handleSetDepartureDates = (dates: string[]) => {
    const newDates = orderDatesAsc(dates);
    setSelectedOriginDates(newDates);
    setDepartureDates(newDates);
  };

  useEffect(() => {
    setSelectedOriginDates(searchState?.departureDates ?? []);
    setDepartureDates(searchState?.departureDates ?? []);
  }, [searchState.departureDates]);

  return (
    <FieldSearch>
      <CalendarBackSvg />
      <DatePickerWithInput
        title="Selecione até 4 datas de ida"
        placeholder="Ida"
        maxSelectableDates={4}
        daysInMonth={daysInMonth}
        selectedDates={selectedOriginDates}
        onDatesChange={handleSetDepartureDates}
        type="origin"
      />
    </FieldSearch>
  );
};
